"use strict";

var apiCheck = require("api-check");
if (!apiCheck) {
  throw new Error("angular-formly requires the library apiCheck.js! Please include it! " + require("./other/docsBaseUrl") + "apicheckjs-dependency-required");
}
var ngModuleName = "formly";
var angular = require("./angular-fix");
var ngModule = angular.module(ngModuleName, []);

require("./providers")(ngModule);
require("./services")(ngModule);
require("./directives")(ngModule);
require("./run")(ngModule);

module.exports = ngModuleName;


/*****************
 ** WEBPACK FOOTER
 ** ./index.common.js
 ** module id = 10
 ** module chunks = 0
 **/